// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReferenceTokenResponse
 */
export interface IReferenceTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof IReferenceTokenResponse
     */
    token_type?: IReferenceTokenResponseTokenTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReferenceTokenResponse
     */
    token_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IReferenceTokenResponse
     */
    token_provider?: string;
}

/**
* @export
* @enum {string}
*/
export enum IReferenceTokenResponseTokenTypeEnum {
    FORMAT_PRESERVING_MULTI_USE = 'FORMAT_PRESERVING_MULTI_USE',
    FORMAT_PRESERVING_SINGLE_USE = 'FORMAT_PRESERVING_SINGLE_USE',
    CLAIM_CHECK_NONCE = 'CLAIM_CHECK_NONCE',
    RANDOM_MULTI_USE = 'RANDOM_MULTI_USE',
    RANDOM_SINGLE_USE = 'RANDOM_SINGLE_USE',
    CLAIM_CHECK_NONCE_WITH_PINCAPTURE = 'CLAIM_CHECK_NONCE_WITH_PINCAPTURE'
}


/**
 * Check if a given object implements the IReferenceTokenResponse interface.
 */
export function instanceOfIReferenceTokenResponse(value: object): value is IReferenceTokenResponse {
    return true;
}

export function IReferenceTokenResponseFromJSON(json: any): IReferenceTokenResponse {
    return IReferenceTokenResponseFromJSONTyped(json, false);
}

export function IReferenceTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReferenceTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token_type': json['tokenType'] == null ? undefined : json['tokenType'],
        'token_id': json['tokenId'] == null ? undefined : json['tokenId'],
        'token_provider': json['tokenProvider'] == null ? undefined : json['tokenProvider'],
    };
}

export function IReferenceTokenResponseToJSON(json: any): IReferenceTokenResponse {
    return IReferenceTokenResponseToJSONTyped(json, false);
}

export function IReferenceTokenResponseToJSONTyped(value?: IReferenceTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenType': value['token_type'],
        'tokenId': value['token_id'],
        'tokenProvider': value['token_provider'],
    };
}

